import { Box, Button, DataTable, Layer, Text } from "grommet";
import React, { useEffect, useRef ,useState} from "react";
import './MedicalEmergencyHomeScreen.css';
import filterIcon from '../../../../../assets/filter_list.svg';
import noActivity from '../../../../../assets/no-activity.png';
import MedicalEmergencyService from "../../../../../services/medical-emergency/medical-emergency.service";
import { useStore } from "../../../../../Hooks/useStore";
import StatusChip from "../../common/status-chip/StatusChip";
import { observer } from "mobx-react";
import activityListIcon from '../../../../../assets/Vector.svg';
import chat from '../../../../../assets/sms.svg';
import video from '../../../../../assets/videocam.svg';
import noResult from "../../../../../assets/no-result.png";
import closeSidebar from "../../../../../assets/close_small.svg";
import { useUser } from "../../../context/User/UserContext";
import { toJS } from "mobx";
import PassengerService from "../../../../../services/passenger/passenger.service";
import { useNavigate } from "react-router-dom";
import { SliderComponent } from "./Slider";
import AssignToSomeoneModal from "../MedicalEmergenciesMainScreen/MedicalEmergencyListScreen/Modal/AssignSomeone";
import CommonSearchInput from "../../common/SearchInput/CommonSearchInput";
import { Mixpanel } from "../../../../../util/Helper";
import EmsService from "../../../../../services/ems/ems.service";
import CommonButton from "../../common/Button/CommonButton";
import Pagination from "../../common/Pagination/Pagination";
import Utility from "../../../../../util/api/Utility";
import { subscribeToTopic } from "../../../../../App";


const MedicalEmergencyHomeScreen = observer(() => {
    const { rootStore } = useStore();
    const { setUser, user } = useUser();
    const navigate = useNavigate();
    const activitiesElement = useRef(null);
    const activeIncidentElement = useRef(null);
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage] = useState(10)

    const isFlightIdSubscribe = useRef(true);
    const incidentFilterRef = useRef(null); // Add ref for emergency filter dropdown
    const activityFilterRef = useRef(null); // Add ref for activity filter dropdown
    

    const handlePageChange = (page)=> {
      rootStore.loadingStore.setShowLoader(true);
      setCurrentPage(page);
      const startIndex = (page - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const getActiveIncidentList = toJS(rootStore.homeScreenStore.getActiveIncidentList).slice(startIndex, endIndex);
      rootStore.homeScreenStore.resetIdsList();
      getActiveIncidentList.map((item) => {
          rootStore.homeScreenStore.setIncidentId(item.id);
      });
      setTimeout(() => {
        rootStore.loadingStore.setShowLoader(false);
      },3000);
    };

    useEffect(() => {
      activeIncident("desc");
    },[]);

  let userInfo;
  useEffect(() => {
    (async () => {
      userInfo = localStorage.getItem("userinfo");
      if (userInfo) {
        let roleLabel = JSON.parse(userInfo).roleLabel;
        rootStore.emsStore.handleRoleLabel(roleLabel);
      }
    })();
  }, [userInfo]);

  // Add useEffect for click-outside detection
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check for emergency filter dropdown
      if (incidentFilterRef.current && !incidentFilterRef.current.contains(event.target)) {
        if (rootStore.homeScreenStore.getActiveIncidentFilter) {
          rootStore.homeScreenStore.setActiveIncidentFilter();
        }
      }
      
      // Check for activity filter dropdown
      if (activityFilterRef.current && !activityFilterRef.current.contains(event.target)) {
        if (rootStore.homeScreenStore.getActivityFilter) {
          rootStore.homeScreenStore.setActivityFilter();
        }
      }
    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);
    
    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [rootStore.homeScreenStore.getActiveIncidentFilter, rootStore.homeScreenStore.getActivityFilter]);

  useEffect(() => {
    if (isFlightIdSubscribe.current) {
      (async () => {
        try {
          let isAdmin = rootStore.emsStore.getRoleLabel.toLowerCase() == "admin";
          const medicalEmergencies_ =
            await MedicalEmergencyService.listMedicalEmergencies(isAdmin);
            console.log("medicalEmergencies_", medicalEmergencies_);
            isFlightIdSubscribe.current = false;
    
          medicalEmergencies_.forEach((emergency, index) => {
            const flightId = emergency.flightPrimaryKey;
            console.log("home testssss" + flightId); //
            console.log(JSON.stringify(rootStore.emsStore.getFlightsubscribe));
            // Check if flightId has already been logged
            if (!rootStore.emsStore.getFlightsubscribe[flightId]) {
              console.log("test" + flightId);
              // Mark this flightId as logged
              rootStore.emsStore.handleFlightsubscribe(flightId);
              subscribeToTopic(flightId, rootStore);
            }
          });
        } catch (error) {
          console.log("listMedicalEmergencies", error);
        }
      })()
    }
  },[]);

    
  useEffect(() => {
    return () => {
        rootStore.emsStore.handleSelectedEmergency(null);
        rootStore.emsStore.passenger = null;
        rootStore.emsStore.handleVideoCallRecord(null);
        rootStore.emsStore.resetReportIndicator();
    }
  }, []);

    const activeIncident = async (order) => {
      rootStore.loadingStore.setShowLoader(true);
      rootStore.homeScreenStore.resetIdsList();
      let activeIncident = await MedicalEmergencyService.getActiveIncident(order);

      const startIndex = (1 - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const getActiveIncidentList = activeIncident.slice(startIndex, endIndex);
      getActiveIncidentList.map((item) => {
          rootStore.homeScreenStore.setIncidentId(item.id);
      })

      rootStore.homeScreenStore.setSelectedFilter(order);
      rootStore.homeScreenStore.setActiveIncident(activeIncident);
      setTimeout(() => {
        rootStore.loadingStore.setShowLoader(false);
      },3000);
    }
    const fetchData = async (page) => {
      try {
        // Example: Fetch active incidents for the current page
        let activeIncidents = await MedicalEmergencyService.getActiveIncidents(page, itemsPerPage);
        rootStore.homeScreenStore.setActiveIncident(activeIncidents);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    useEffect(() => {
      getActivity("desc");
    },[user,rootStore.homeScreenStore.getIncidentList]);

    useEffect(() => {
      newlyIncident();
    },[user]);

    const getActivity = async (order) => {
      if (user) {
        let ids = rootStore.homeScreenStore.getIncidentList;
        let activities = await MedicalEmergencyService.getActivity(user.username, ids, order);
        rootStore.homeScreenStore.setActivity(activities);
      }
    }

    const newlyIncident = async () => {
      let newIncident = await MedicalEmergencyService.getNewIncident();
      let reverseData = newIncident.reverse();
      rootStore.homeScreenStore.setNewIncident(reverseData);
    }

      const getTimeWithInfo = (hourCount) => {
        if (hourCount > 12) {
          return "am";
        } else {
          return "pm"
        }
      }
    
    const getPrettyTime = (date) => {
      let formattedTime = Utility.getFormatedTime(date);
      console.log("formattedTime",formattedTime);
      return formattedTime;
    };
  
    const getFormatedDate = (date) => {
      let localDateTime = Utility.convertUTCToLocal(date);
      let formattedDate = Utility.getFormatedDate(localDateTime);
      return formattedDate;
    };
      

    
    const Columns = [
          {
            align: "center",
            property: 'Flight No',
            header: <Text>Flight No</Text>,
            primary: true,
            render: item => {
                return(
                  <Text>{item.flightId}</Text>  
                )
              }
          },
          {
            align: "center",
            property: 'Date',
            header: <Text>Date</Text>,
            primary: true,
            render: item => (
                <Text>{getFormatedDate(item.timestamp)}</Text>
            )
          },
          {
            align: "center",
            property: 'Time',
            header: <Text>Time</Text>,
            primary: true,
            render: item => (
                <Text>{getPrettyTime(item.timestamp)}</Text>
            )
          },
          {
            align: "center",
            property: 'Status',
            header: <Text style={{textAlign: 'center'}}>Status</Text>,
            primary: true,
            render: item => (
                <Text style={{textAlign: 'center'}}><StatusChip status={item.status} /></Text>
            )
          },
          // {
          //   property: 'Action',
          //   header: <Text style={{textAlign: 'center'}}>Action</Text>,
          //   primary: true,
          //   render: item => (
          //       <Text style={{textAlign: 'center'}} onClick={() => assignToSomeoneTxtClick(item.id)} className="home-action">Assign to Someone</Text>
          //   )
          // }
          {
            align: "center",
            property: 'Action',
            header: <Text style={{textAlign: 'center'}}>Action</Text>,
            primary: true,
            render: item => (
              <Text
                style={{textAlign: 'center'}}
                onClick={(event) => {
                  event.stopPropagation(); // Prevent row click
                  assignToSomeoneTxtClick(item.id);
                }}
                className="home-action"
              >
                Assign to Someone
              </Text>
            ),
          },
        
    ];
        // <Pagination
        //   currentPage={1}
        //   // totalPages={Math.ceil(originalFlightList.length / itemsPerPage)}
        //   totalPages={10}
        //   totalItems={20}
        //   onPageChange={()=>{}}
        // />

    const assignToSomeoneTxtClick = async (id) => {
      Mixpanel.track("web_assign_to_someone_click_in_home_screen",{name:user?.username});
      try {
        let emsList = await EmsService.listEmsProviders();
        rootStore.homeScreenStore.EmsList = emsList;
        rootStore.homeScreenStore.handleSelectedMedicalIdList(id);
        rootStore.homeScreenStore.handleAssignSomeoneModal(true);
      } catch (e) { }
    }

    const onEmergencyFilterClick = () => {
      rootStore.homeScreenStore.setActiveIncidentFilter();
    }

    const onActivityFilterClick = () => {
      rootStore.homeScreenStore.setActivityFilter();
    }

    const onAssignEmergencyClicked = async () => {
      Mixpanel.track("web_assign_emergency_click",{name:user?.username});
      if (rootStore.homeScreenStore.selectedEmsId === "") {
        alert("Please select a provider");
        return;
      }
      rootStore.homeScreenStore.handleEmsListSearch("")
      rootStore.loadingStore.setShowLoader(true);
      try {
        const selectedMedicalList = rootStore.homeScreenStore.getSelectedMedicalList;
             
        await MedicalEmergencyService.setSingleMedicalEmergencyEms(
          selectedMedicalList,
          rootStore.homeScreenStore.selectedEmsId
        );
        let msg = `Medical Incident is assigned to ${rootStore.homeScreenStore.selectedEmsId}`
      rootStore.notificationToastStore.showNotification(msg,false, 3000);
        // rootStore.homeScreenStore.handleAssignToSomeoneModal(true);
      } catch (e) { }
      rootStore.loadingStore.setShowLoader(false);
      rootStore.homeScreenStore.handleAssignSomeoneModal(false);
      rootStore.homeScreenStore.handleEmsSearchString("");
      rootStore.homeScreenStore.handleSelectEmsId("");
      // rootStore.homeScreenStore.handleAssignToSomeoneModal(false);
    };

    const filteredEmsList =
    rootStore.emsStore.getemsSearchString === ""
      ? rootStore.homeScreenStore.EmsList
      : rootStore.homeScreenStore.EmsList.filter((ems) =>
        (ems.name + " " + ems.familyName)
          .toLowerCase()
          .includes(rootStore.homeScreenStore.getemsSearchString.toLowerCase())
      );

    

    useEffect(() => {
      if (activitiesElement.current) {
        activitiesElement.current.scrollTop = 0;
      }
    },[rootStore.homeScreenStore.getActivityList,rootStore.homeScreenStore.getActiveIncidentList]);

    useEffect(() => {
      if (activeIncidentElement.current) {
        activeIncidentElement.current.scrollTop = 0;
      }
    },[rootStore.homeScreenStore.getActiveIncidentList]);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const getActiveIncidentList = rootStore.homeScreenStore.getActiveIncidentList.slice(startIndex, endIndex);
    return (
      <>
      {/* <AssignToSomeoneModal isShow={rootStore.homeScreenStore.getAssignToSomeoneModal} /> */}
        <Box className="home-screen-container">
            <Box className="left-home-content" style={{width: rootStore.homeScreenStore.getToggleDesign ? "100%" : "70%"}}>
              {
                rootStore.homeScreenStore.getNewIncidentList.length > 0
                 &&
                <div style={{display: 'flex'}}>
                  <SliderComponent slides={rootStore.homeScreenStore.getNewIncidentList} />
                  {
                    rootStore.homeScreenStore.getToggleDesign
                    &&
                    <div className="toggle-button">
                    <Box className="round-shape" onClick={() => rootStore.homeScreenStore.handleToggleDesign()}>
                      <img src={activityListIcon} />
                    </Box>
                  </div>
                  }
                </div>
              }
                <Box className="active-incident-emergency-list">
                    <Box className="heading-row-outer">
                        <Text className="active-incident-heading">Active Incidents</Text>
                        <Box className="filter-icon-shape" onClick={onEmergencyFilterClick} ref={incidentFilterRef}>
                            <img src={filterIcon} alt="filter icon" />
                            {
                              rootStore.homeScreenStore.getActiveIncidentFilter
                               &&
                              <Box className="dropdown">
                                  <ul className="list">
                                    <li onClick={() => activeIncident("desc")} style={{backgroundColor: rootStore.homeScreenStore.getSelectedFilter == "desc" ? "#E9F2FF" : "#fff"}}>Newest</li>
                                    <li onClick={() => activeIncident("asc")} style={{backgroundColor: rootStore.homeScreenStore.getSelectedFilter == "asc" ? "#E9F2FF" : "#fff"}}>Oldest</li>
                                  </ul>
                              </Box>
                            }
                        </Box>
                    </Box>
                    <Box className="table-outer" ref={activeIncidentElement}>
                        <DataTable
                            className="active-incident-emergency-table"
                            data={getActiveIncidentList}
                            resizeable
                            step={10}
                            onClickRow={({ datum }) => {
                              if (
                                rootStore.emsStore.getRoleLabel.toLowerCase() == "admin"
                              ) {
                                return;
                              }
                              let path = "/ems/medical-emergencies/emergency/" + datum.id;
                              navigate(path);
                            }}
                            columns={Columns}
                        />
                        {
                          rootStore.homeScreenStore.getActiveIncidentList.length == 0
                            &&
                          <Box className="no-result-img">
                            <img src={noResult} alt="no emergency found" />
                            <p>No active incidents found.</p>
                          </Box>
                        }
                        
                    </Box>
            <Pagination
         currentPage={currentPage}
         totalPages={Math.ceil(rootStore.homeScreenStore.getActiveIncidentList.length / itemsPerPage)}
        // totalPages={1}

         totalItems={rootStore.homeScreenStore.getActiveIncidentList.length} 
        //  totalItems={12} 

         onPageChange={handlePageChange}
         paginationShow={rootStore.homeScreenStore.getActiveIncidentList.length > itemsPerPage}
       /> 
            </Box>

            </Box>
              
            <Box style={{display: rootStore.homeScreenStore.getToggleDesign ? "none" : "block"}} className={rootStore.homeScreenStore.getActivityList.length == 0 ? "right-home-content empty" : "right-home-content"}>
              <Box className="activity-header">
                <Box className="heading-outer">
                  <Box className="heading-row-outer">
                    <Box className="round-shape" onClick={() => rootStore.homeScreenStore.handleToggleDesign()}>
                      <img src={activityListIcon} />
                    </Box>
                    <Text className="activity-txt">Activities</Text>
                  </Box>
                  <Box className="filter-icon-shape" onClick={onActivityFilterClick} ref={activityFilterRef}>
                      <img src={filterIcon} alt="filter icon" />
                      {
                        rootStore.homeScreenStore.getActivityFilter
                          &&
                        <Box className="dropdown">
                            <ul className="list">
                              <li onClick={() => getActivity("desc")}>Newest</li>
                              <li onClick={() => getActivity("asc")}>Oldest</li>
                            </ul>
                        </Box>
                      }
                  </Box>
                </Box>
              </Box>

              <Box className="action-card-main" ref={activitiesElement}>
                {
                  rootStore.homeScreenStore.getActivityList.length > 0
                    ?     
                    rootStore.homeScreenStore.getActivityList.map((activity) => {
                      console.log("activity",toJS(activity));
                      return <ActivityCard activity={activity} />;
                    })
                    :
                  <Box className="no-activity-history">
                    <img src={noActivity} alt="filter icon" />
                    <Text className="no-activity-txt">No activities to show, start treatment to see flight updates.</Text>
                  </Box>
                }
              </Box>
            </Box>
        </Box>

        {rootStore.homeScreenStore.getAssignSomeoneModal && (
    <Layer
      full="vertical"
      position="right"
      onClickOutside={() => {rootStore.homeScreenStore.handleAssignSomeoneModal(false);rootStore.homeScreenStore.handleSelectEmsId("");rootStore.homeScreenStore.handleEmsListSearch("")}}
      onEsc={() => {rootStore.homeScreenStore.handleAssignSomeoneModal(false);rootStore.homeScreenStore.handleSelectEmsId("");rootStore.homeScreenStore.handleEmsListSearch("")}}
      style={{borderRadius: "12px 0 0 12px", zIndex: 1000,overflowY:'scroll' }}
    >
      <Box className="sidebar-title">
        <h4>Assign to someone</h4>
        <Button onClick={() => {rootStore.homeScreenStore.handleAssignSomeoneModal(false);rootStore.homeScreenStore.handleSelectEmsId("");rootStore.homeScreenStore.handleEmsListSearch("")}}><img src={closeSidebar} style={{width: 20, height: 20}}/>Close</Button>
      </Box>
      <Box style={{padding: "12px 14px 0 14px", marginBottom: 18,position: 'relative'}}>
        <CommonSearchInput onchange={(e) => rootStore.homeScreenStore.handleEmsListSearch(e.target.value)} />
        {
          rootStore.homeScreenStore.getEmsListSearch.trim() != ""
          &&
        <Box className="searchBox">
          {
              filteredEmsList.map((ems) => {
                if ((ems.name + " " + ems.familyName).toLocaleLowerCase().replaceAll(" ","").includes(rootStore.homeScreenStore.getEmsListSearch.toLocaleLowerCase().replaceAll(" ",""))) {
                  return(
                    <Text onClick={() => {
                      rootStore.homeScreenStore.handleEmsListSearch("");
                      rootStore.homeScreenStore.handleSelectEmsId(ems.id);
                    }} className={rootStore.homeScreenStore.getSelectedEmsId == ems.id ? "searchListItem2" : "searchListItem"}>{ems.name + ems.familyName}</Text>
                  )
                } else {
                  return null;
                }
              })
            }
        </Box>
        }
      </Box>
      <Box style={{padding: "0 20px 16px 20px",height: '87%'}}>
        <Box className="esmlist">
          {
            filteredEmsList.map((ems) => {
              return(
                <Text onClick={() => rootStore.homeScreenStore.handleSelectEmsId(ems.id)} className={rootStore.homeScreenStore.getSelectedEmsId == ems.id ? "listItem2" : "listItem"}>{ems.name + " " + ems.familyName}</Text>
              )
            })
          }
        </Box>
      <CommonButton
        title="Assign"
        padding="8px 12px"
        color={rootStore.homeScreenStore.getSelectedEmsId=="" ? "#A7B6D1" : "#fff"}
        bgColor={rootStore.homeScreenStore.getSelectedEmsId=="" ? "#E9F2FF" : "#357EFF"}
        radius={10}
        border="1px solid #E9F2FF"
        lineheight="20px"
        disabled={rootStore.homeScreenStore.getSelectedEmsId=="" ? false : true}
        isDisableApply={true}
        onclick={onAssignEmergencyClicked}
        className="assignButton"
        width="100%"
      />
      </Box>
    </Layer>
  )}
      </>
    );
});


export default MedicalEmergencyHomeScreen;


const ActivityCard = ({ activity }) => {
  const navigate = useNavigate();
  return(
    <div className="activity-card">
    <Text className="medical-incident-title">Medical Incident - {activity.medicalEmergencyId}</Text>
    <Box className="activity-detail">
        <Box className="person-detail">
            <Box className="picture"></Box>
            <Text className="person-name">{activity.actionBy}</Text>
        </Box>
        <Box className="icons">
          <img src={chat} className="chat-icon" onClick={() => navigate(`/ems/medical-emergencies/emergency/${activity.medicalEmergencyId}`)}/>
          <img src={video} className="video-icon" onClick={() => navigate(`/ems/medical-emergencies/emergency/${activity.medicalEmergencyId}`)}/>
        </Box>
    </Box>
    <Box className="report-info">
      <Text>{activity.actionTaken}.</Text>
    </Box>
    <Text className="time-log">{Utility.timelog(activity.timestamp)}</Text>
    <button onClick={() => navigate(`/ems/medical-emergencies/emergency/${activity.medicalEmergencyId}`)} className="check-btn">Check</button>
  </div>
  )
}

